import { servicePost } from "./client.ts";
import { batchedServicePost } from "./readBatch.ts";
import type { ReturnObject } from "../types/returnObject.ts";

export interface TicketTech {
  ID: number;
  Firstname: string;
  Lastname: string;
  Email: string;
  Phone: string;
  Phone2: string;
  ExtraInfo: string;
  Prio: number;
  IsTechnician: boolean;
}

/** Get all technicians NOT assigned to the given location. */
export async function getTicketTechs(locationID: number): Promise<ReturnObject<TicketTech[]>> {
  return batchedServicePost<TicketTech[]>("WebGetTicketTechs", { locationID });
}

/** Get technicians assigned to the given location (ordered by priority). */
export async function getTechsForLocation(locationID: number): Promise<ReturnObject<TicketTech[]>> {
  return batchedServicePost<TicketTech[]>("WebGetTechsForLocation", { locationID });
}

/** Get technicians + merchandiser for a location (used by ticket page). */
export async function getTechsMerchForLocation(locationID: number): Promise<ReturnObject<TicketTech[]>> {
  return servicePost<TicketTech[]>("WebGetTechsMerchForLocation", { locationID });
}

/** Create a new technician. */
export async function createTicketTech(tech: TicketTech): Promise<ReturnObject<boolean>> {
  return servicePost<boolean>("WebCreateTicketTech", { tech });
}

/** Update an existing technician. */
export async function saveTicketTech(tech: TicketTech): Promise<ReturnObject<boolean>> {
  return servicePost<boolean>("WebSaveTicketTech", { tech });
}

/** Save the full list of technicians for a location (replaces existing assignments). */
export async function saveTechniciansForLocation(techs: TicketTech[], locationID: number): Promise<ReturnObject<boolean>> {
  return servicePost<boolean>("WebSaveTechniciansForLocation", { techs, locationID });
}
